export const osnSubtitleIcon = {
  /* eslint-disable max-len */
  data: `<svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M33.0256 9.25C34.6728 9.25212 36.163 9.93019 37.2424 11.0233C38.3275 12.122 38.9979 13.6396 39 15.3134L39 27.9692C38.9979 29.645 38.3275 31.1626 37.2424 32.2614C36.163 33.3545 34.6728 34.0325 33.0278 34.0346H30.4213L24.2614 39.25L17.5787 34.0346H14.9744C13.3272 34.0325 11.837 33.3545 10.7576 32.2614C9.67253 31.1626 9.0021 29.645 9 27.9713L9 15.3155C9.0021 13.6396 9.67253 12.122 10.7576 11.0233C11.837 9.93019 13.3272 9.25212 14.9722 9.25L33.0256 9.25Z" stroke="currentColor" stroke-width="3"/>
  <rect x="15" y="24.25" width="18" height="3" rx="1.5" fill="currentColor"/>
  <rect x="15" y="17.25" width="8" height="3" rx="1.5" fill="currentColor"/>
  </svg>
  `,
  name: 'subtitle',
};
